import React, { useState, useEffect } from 'react'

import { Dialog, DialogTitle, DialogContent, Typography } from '@material-ui/core'

import moment from 'moment'

import { makeStyles, confirmActivation } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	grid: {
		display: 'grid',
		gridTemplateColumns: '188px 188px',
		marginBottom: '28px'
	},
	fieldWrapper: {
		'& .MuiTextField-root': { minWidth: '378px' }
	},
	summaryHeader: {
		fontSize: '12px',
		color: '#1A1A35',
		fontWeight: '800',
		opacity: '.75'
	},
	text: {
		color: '#1A1A35',
		fontSize: '14px'
	},
	subTitle: {
		fontWeight: '800',
		fontSize: '12px',
		paddingBottom: '22px',
		textTransform: 'uppercase'
	},
	subTitle2: {
		fontWeight: '600',
		fontSize: '16px',
		color: '#4D4C4F'
	},
	info: {
		fontWeight: '600',
		fontSize: '16px'
	},
	grayBox: {
		height: 90,
		width: '100%',
		borderRadius: 6,
		backgroundColor: '#F9F9F9',
		paddingLeft: 12,
		paddingRight: 12,
		paddingTop: 16
	}
}))

const getStatus = (data) => {
	if (data.checked_in) {
		if (data.expired) {
			return 'Complete'
		}
		return 'Checked In'
	} else {
		if (!data.checked_in) {
			if (data.expired) {
				return 'Expired'
			}
			return 'Waiting'
		}
	}
}

const getEntryMethod = (data) => {
	if (!data.checked_in) return 'N/A'

	if (data.access_method) {
		return data.access_method
	} else return 'N/A'
}

const getPeople = (data, accounts) => {
	if (!data.account_ids || (data.account_ids && !data.account_ids.length)) return 'N/A'

	return data.account_ids.filter(a => !!a).map((a) => {
		let acct = accounts.find(ac => ac._id == a)
		return acct?.full_name || ''
	}).join(', ')
}

const getGuests = (data) => {
	if (!data.guests || (data.guests && !data.guests.length)) return 'N/A'

	return data.guests.map((guest) => guest.name).join(', ')
}

const getPets = (data) => {
	if (!data.pets || (data.pets && !data.pets.length)) return 'N/A'

	return data.pets.map((pet) => pet.name).join(', ')
}

const MemberActivityDialog = (props) => {
	const classes = useStyles()

	let { isShown, setIsShown, checkIn, accounts } = props
	if (!checkIn) checkIn = {}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px',
					height: 'auto'
				}
			}}>
			<DialogTitle
				style={{
					fontSize: '16px',
					fontWeight: '800',
					paddingBottom: 16
				}}>
				ACTIVITY DETAIL
			</DialogTitle>
			<DialogContent style={{ paddingBottom: 24 }}>
				<div className={classes.grid}>
					<Typography className={classes.subTitle}>Date & Time</Typography>
					<Typography className={classes.info}>
						{' '}
						{checkIn.time_checked_in
							? checkIn.time_checked_in
							: moment(checkIn.createdAt).format('MMMM Do, YYYY, h:mm a')}
					</Typography>
					<Typography className={classes.subTitle}>Status</Typography>
					<Typography className={classes.info}>{getStatus(checkIn)}</Typography>
					<Typography className={classes.subTitle}>Entry Method</Typography>
					<Typography className={classes.info} style={{ textTransform: 'capitalize' }}>
						{getEntryMethod(checkIn)}
					</Typography>
					<Typography className={classes.subTitle}>People</Typography>
					<Typography className={classes.info}>{getPeople(checkIn, accounts)}</Typography>
					<Typography className={classes.subTitle}>Guests</Typography>
					<Typography className={classes.info}>{getGuests(checkIn)}</Typography>
					<Typography className={classes.subTitle}>Pets</Typography>
					<Typography className={classes.info}>{getPets(checkIn)}</Typography>
				</div>
				<div>
					<Typography className={classes.subTitle} style={{ paddingBottom: 8 }}>CONTACTS CHARGED PRIVATE BAR DUES</Typography>
					<div className={classes.grayBox}>
						<Typography className={classes.subTitle2}>{checkIn.accounts_charged && checkIn.accounts_charged.map(a => {
							let acct = accounts.find(ac => ac._id == a)
							return `${acct.first_name} ${acct.last_name}`
						}).join(', ')}</Typography>
					</div>
				</div>
				<div>
					<Typography className={classes.subTitle} style={{ marginTop: 16, paddingBottom: 8 }}>Guests with signed waiver & Scanned ID</Typography>
					<div className={classes.grayBox}>
						<Typography className={classes.subTitle2}>{checkIn.guests && checkIn.guests.filter(g => g.signed_waiver).map(a => {
							return a.name
						}).join(', ')}</Typography>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default MemberActivityDialog
